import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { UserReportsType } from '@app/pages/ssoManager/addEditApplication.enums';
import { reportsService } from '@app/services';
import { AxiosResponse } from 'axios';
import { infiniteScrollItemsFetchLimit } from '@app/helpers';
import { PasslyTable } from '@app/components';
import { handleSetSnackbar } from '@app/store/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import { defaultHeadCells, headCellsForUserBeenDoingLately } from '@app/pages/reports/components/tableHeaders.object';
import { IProps } from '@app/pages/reports/components/reports.interface';

export const UserReports: React.SFC<IProps> = ({ userReportSelected, userSelected, resetLocal }) => {
    const { translation } = useTypedTranslation();
    const [rows, setRows] = useState<any>([]);
    const [isShowLoader, setIsShowLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rowsCount, setRowsCount] = useState(0);
    const isUserBeenDoingLatelyChosen = userReportSelected === UserReportsType.userBeenDoingLately;
    const dispatch = useDispatch();

    const handleSuccess = (name: any, isReset: boolean) => (res: AxiosResponse) => {
        setIsShowLoader(false);

        if (res.data.items && !isReset) {
            setRows((previousState: any) => previousState.concat(res.data.items));
        }

        if (isReset) {
            setRows(res.data.items);
            setRowsCount(res.data.count);
        }
    };

    const handleError = (error: any) => {
        setIsShowLoader(false);
        setErrorMessage(error.response.data.message);
    };

    const getHeaderItems = () => {
        return isUserBeenDoingLatelyChosen ? headCellsForUserBeenDoingLately : defaultHeadCells;
    };

    useEffect(() => {
        if (errorMessage) {
            dispatch(handleSetSnackbar({ show: true, message: errorMessage, severity: 'error' }));
        }
    }, [errorMessage]);

    const fetchMoreData = (skipCount: number, isReset: boolean) => {
        if (!userSelected) {
            return;
        }

        setIsShowLoader(isReset);

        switch (userReportSelected) {
            case UserReportsType.userSee:
                reportsService
                    .getUserSeeReports(userSelected, skipCount, infiniteScrollItemsFetchLimit)
                    .then(handleSuccess('userReports', isReset))
                    .catch(handleError);

                break;
            case UserReportsType.userSeen:
                reportsService
                    .getUserSeenReports(userSelected, skipCount, infiniteScrollItemsFetchLimit)
                    .then(handleSuccess('userReports', isReset))
                    .catch(handleError);

                break;
            case UserReportsType.userStillKnow:
                reportsService
                    .getUserStillKnowReports(userSelected, skipCount, infiniteScrollItemsFetchLimit)
                    .then(handleSuccess('userReports', isReset))
                    .catch(handleError);

                break;
            case UserReportsType.userBeenDoingLately:
                reportsService
                    .getUserBeenDoingLatelyReports(userSelected, skipCount, infiniteScrollItemsFetchLimit)
                    .then(handleSuccess('userReports', isReset))
                    .catch(handleError);
                break;
        }
    };

    return (
        <div className='reports__table'>
            <PasslyTable
                rows={rows}
                headerItems={getHeaderItems()}
                hideFilter={true}
                rowsCount={rowsCount}
                onFetch={fetchMoreData}
                withCheckboxes={false}
                emptyListHelper={translation('REPORT_MANAGER_USER_EMPTY_REPORTS_LIST')}
                loadingData={isShowLoader}
                resetLocal={resetLocal}
            />
        </div>
    );
};
